import clsx from 'classnames';
import React from 'react';

import { useBrowserScreen } from '~/components/ExtendedGlobalHeader/hooks/useBrowserScreen';

type LogoItem = {
  imgSrc: string;
  url: string;
  alt?: string;
  brandTitle: string;
};

type LogoListProps = {
  heading: string;
  isDivider?: boolean;
  items: LogoItem[];
  className?: string;
};

const LogoList: React.FC<LogoListProps> = ({
  heading,
  isDivider,
  items,
  className = '',
}) => {
  const headingId = React.useId();
  const { isDesktopView } = useBrowserScreen();

  return (
    <section
      className={clsx(
        'llogos',
        { 'llogos--isMobile': !isDesktopView },
        {
          'llogos--divider': isDivider && isDesktopView,
        },
        className
      )}
      aria-labelledby={headingId}
    >
      <h3 id={headingId} className="llogos__heading">
        {heading}
      </h3>

      <ul className="llogos__grid">
        {items.map(({ imgSrc, url, alt, brandTitle }, i) => (
          // eslint-disable-next-line react/no-array-index-key

          <li key={i} className="llogos__item">
            <a
              className="llogos__link"
              href={url}
              aria-label={alt || `Brand ${i + 1}`}
            >
              {!isDesktopView ? (
                <span className="llogos__title">{brandTitle}</span>
              ) : (
                <img className="llogos__img" src={imgSrc} alt={alt || ''} />
              )}
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default LogoList;
